module.exports = __webpack_public_path__ + "img/drh5_share_tc.3941a26a.png";